module.exports = __webpack_public_path__ + "static/media/inbox-off.3cfc307c.svg";